export function isValidOrigin(originUrl: string) {
  try {
    const url = new URL(originUrl);
    /**
     * NOTE:
     * This is a regex that matches any subdomain of lamimed.it
     * Examples:
     * - lamimed.it - valid
     * - api.lamimed.it - valid
     * - lamimed.it:8080 - valid
     * - google.com - invalid
     */
    const validDomainRegex = /^(?:.*\.)?lamimed\.it$/;

    return validDomainRegex.test(url.hostname);
  } catch {
    return false;
  }
}
